import React from 'react';
import { Row, Col, Button, Modal, Form, InputGroup, Breadcrumb } from 'react-bootstrap';
import { CancelIcon, SearchIcon } from '../ui/icons';
import TreeView from '../treeView';
import { useCreateEditGroup } from './useCreateEditGroup';

const CreateEditGroupModal = () => {
  
  const { displayName,
    checkedBox,
    showParentGroup,
    selectedRadio,
    nodesToDisplay,
    groupSearchQuery,
    handleDisplayNameInputChange,
    handleAddButtonClick,
    handleClose, 
    handleRadioChange,
    handleGroupInputChange,
    clearDisplayNameField,
    handleDataFromTreeView,
    isEdit,
    isModalActive,
    } = useCreateEditGroup();

  return (
    <>
      <Modal show={isModalActive} onHide={handleClose} className='modal-container' centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Group' : 'Create Group'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='add-group-container'>
            <label>Group Name</label>
            <Row>
              <Col sm={6}>
                <div className='add-group-input'>
                  <InputGroup>
                    <Form.Control placeholder="Type in the group name..." aria-label="Search" aria-describedby="basic-addon2" value={displayName} onChange={handleDisplayNameInputChange}/>
                    <Button onClick={clearDisplayNameField}>
                      <CancelIcon></CancelIcon>
                    </Button>
                  </InputGroup>
                </div>
                <div className='create-edit-group-radio'>
                  <p>Assign this under another group?</p>
                  <Form>
                    {['Yes', 'No'].map((value) => (
                      <div key={value + (isEdit ? "EDIT" : "")}>
                        <Form.Check
                          id={value}
                          label={value}
                          type='radio'
                          checked={selectedRadio == value}
                          onChange={() => handleRadioChange(value)}
                        />
                      </div>
                    ))}
                  </Form>
                </div>
              </Col>

              <Col sm={1}>
                <div className='line'></div>
              </Col>
              <Col sm={5}>
                {showParentGroup && (
                  <div className="assign-roles-tree-container">
                    <div className="assign-roles-search">
                      <InputGroup>
                        <Form.Control placeholder="Search" aria-label="Search" aria-describedby="search-tree-list" value={groupSearchQuery} onChange={handleGroupInputChange}/>
                        <InputGroup.Text id="search-tree-list"><SearchIcon /></InputGroup.Text>
                      </InputGroup>
                    </div>
                    <div className="assign-roles-tree">
                      <TreeView checkedBox={checkedBox} nodes={nodesToDisplay} onDataFromTreeView={handleDataFromTreeView} isModalOrg={true}></TreeView>
                    </div>
                  </div>
                )}
              </Col>
            </Row>

          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-style' onClick={handleAddButtonClick}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

CreateEditGroupModal.defaultProps = {
  isEdit: false
}
export default CreateEditGroupModal;